module.exports = __webpack_public_path__ + "img/48.2977eff4.jpg";